import { render, staticRenderFns } from "./googleorsocial.vue?vue&type=template&id=cc162328&scoped=true"
import script from "./googleorsocial.vue?vue&type=script&lang=js"
export * from "./googleorsocial.vue?vue&type=script&lang=js"
import style0 from "./googleorsocial.vue?vue&type=style&index=0&id=cc162328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc162328",
  null
  
)

export default component.exports